import { createEvent, createStore } from "effector";

export const openWelcomeModal = createEvent();
export const closeWelcomeModal = createEvent();

export const $isWelcomeModalOpen = createStore(false)
  .on(openWelcomeModal, () => true)
  .on(closeWelcomeModal, () => false);
